import { render, staticRenderFns } from "./ExpressDeliveryDialog.vue?vue&type=template&id=70efbf99"
import script from "./ExpressDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./ExpressDeliveryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports